<template>
  <a
    :href="whatsAppUrl"
    class="whatsapp-fab"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp ile iletişime geç"
  >
    <span class="wa-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.967-.273-.099-.472-.149-.672.15-.198.297-.768.966-.941 1.164-.173.198-.347.223-.644.074-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.173.198-.297.298-.495.099-.198.05-.372-.025-.521-.075-.149-.672-1.611-.922-2.206-.242-.579-.487-.5-.672-.51l-.572-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.999-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.886 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.944L0 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.82 11.82 0 0 0-3.54-8.415Z"/>
      </svg>
    </span>
    <span class="wa-text">WhatsApp</span>
  </a>
  
</template>

<script>
export default {
  name: 'WhatsAppButton',
  props: {
    message: {
      type: String,
      default: 'Merhaba, bilgi almak istiyorum.'
    }
  },
  computed: {
    whatsAppUrl() {
      // +90 552 683 34 09 -> 905526833409
      const raw = '+90 552 683 34 09'.replace(/\D/g, '')
      const phone = raw.startsWith('90') ? raw : `90${raw}`
      const text = encodeURIComponent(this.message)
      return `https://wa.me/${phone}?text=${text}`
    }
  }
}
</script>

<style scoped>
.whatsapp-fab {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 999px;
  background: #25D366;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 8px 20px rgba(37, 211, 102, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  /* Hareketliliği artır: daha sık kısa wiggle + yumuşak parıltı */
  animation: subtleWiggle 5s ease-in-out infinite, pulseGlow 3s ease-in-out infinite;
}

.whatsapp-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(37, 211, 102, 0.45);
}

.wa-icon {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1ebe5d;
  border-radius: 50%;
}

.wa-icon svg {
  width: 22px;
  height: 22px;
  display: block;
}

.wa-text {
  font-size: 14px;
}

@keyframes subtleWiggle {
  0%   { transform: translateY(0) rotate(0); }
  3%   { transform: translateY(-2px) rotate(-8deg); }
  6%   { transform: translateY(0) rotate(8deg); }
  9%   { transform: translateY(-2px) rotate(-6deg); }
  12%  { transform: translateY(0) rotate(0); }
  100% { transform: translateY(0) rotate(0); }
}

@keyframes pulseGlow {
  0%   { box-shadow: 0 8px 20px rgba(37, 211, 102, 0.30); }
  50%  { box-shadow: 0 10px 26px rgba(37, 211, 102, 0.55); }
  100% { box-shadow: 0 8px 20px rgba(37, 211, 102, 0.30); }
}

/* Tablet */
@media (max-width: 1024px) {
  .whatsapp-fab {
    right: 18px;
    bottom: 18px;
    padding: 12px 16px;
  }
  .wa-icon { width: 32px; height: 32px; }
  .wa-text { font-size: 13px; }
}

/* Telefon */
@media (max-width: 640px) {
  .whatsapp-fab {
    right: 14px;
    bottom: 14px;
    padding: 14px 16px;
  }
  .wa-icon { width: 34px; height: 34px; }
  .wa-text { display: none; } /* Küçük ekranda sadece ikon kalsın */
}
</style>


